<div class="sub-header-container {{section}}">
    <div class="icon">
        <img src="assets/icons/{{section}}.svg" />
    </div>
    <h2>{{label}}</h2>
    <p>{{content}}</p>
</div>
